export default __webpack_public_path__ + "static/media/feature4_2.da5ee99a.png";